export const errorMessageDefault =
  'Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'
